import { useState } from "react";
import { FPaquetesStyle } from "./styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
} from "@material-ui/core";
import useCatalogos from "../../../hooks/useCatalogos"
import { useDispatch, useSelector } from "react-redux"
import { nuevaImagenTipoPaqueteMayorista } from "../../../ducks/proveedorMayoristaDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import UploadInput from "../../../global/UploadInput"
import { getBase64 } from "../../../utils/fileBase64"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import Galeria from "../../ProveedorMayorista/FPaquetesGaleria/galeria";
import { closeModalImagenesAction } from "../../../ducks/proveedorTerrestreDuck";

const FPaquetesGaleria = () => {
  const dispatch = useDispatch()
  const classes = FPaquetesStyle()
  const catTipoImagenes = useCatalogos("TipoImagen")
  const [file, setFile] = useState([])
  const [isGaleria, setIsGaleria] = useState(false)
  const [idTipoImagen, setIdTipoImagen] = useState(0)
  const { openModalImagenes, paqueteSelect } = useSelector(store => store.proveedorTerrestre);

  const onGuardar = () => {
    if (file.length > 0) {
      dispatch(onLoadAnction({message: "Este proceso puede tardar varios minutos..."}))
      file.forEach(async (archivo) => {
        await getBase64(archivo).then((result) => {
          const Logobase64 = String(result).split(",")[1];
          const extencion =  archivo.name.split(".")[archivo.name.split(".").length - 1]
          // let payload = {
          //   IdPaquete: idPaquete,
          //   ClavePaquete: clavePaquete,
          //   TipoImagen: {
          //     IdTipoImagen: idTipoImagen,
          //   },
          //   ImagenBase64: Logobase64,
          //   ExtensionImagen:
          //     archivo.name.split(".")[archivo.name.split(".").length - 1],
          // };
          dispatch(nuevaImagenTipoPaqueteMayorista({ 
            extencion: extencion, 
            idPaquete: paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista, 
            imagen: Logobase64, 
            tipoImagen: idTipoImagen
          })).then((Response) => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
              ToastMessage.fire({
                icon: "error",
                title: "Ha habido un problema de conexión con el servidor",
              })
              return
            }
            if (Response.status === 400) {
              ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
              })
              return
            }
            LimpiarForm();
            ToastMessage.fire({
              icon: "success",
              title: "Ingreso Correcto",
            });

          })
        })
      })
    } else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Seleccione por lo menos una imagen.",
      })
    }
  }
  const LimpiarForm = () => {
    setIdTipoImagen(0)
    setFile([])
    setIsGaleria(false)
  }
  const handleClose = () => {
    LimpiarForm()
    dispatch(closeModalImagenesAction());
  }
  const handleSelecTipoImagen = (event) => {
    setIdTipoImagen(event.target.value)
  }
  const onGaleria = () => {
    setIsGaleria(!isGaleria)
  }

  return (    
      <ModalBase classes={classes} open={openModalImagenes} onClose={handleClose}>
        <HeaderModal
          titulo={`Galeria para el paquete ${paqueteSelect?.Nombre}`}
          handleClose={handleClose}
        />
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            {isGaleria && <Galeria
              idPaquete={paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista}
              clavePaquete={paqueteSelect?.PaqueteMayorista?.ClavePaquete}
            />}

            {!isGaleria && (
              <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.imageTypeContainer}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="lTipoImagen">Imagen</InputLabel>
                    <Select
                      labelId="lTipoImagen"
                      id="STipoImagen"
                      name="tipoImagen"
                      value={idTipoImagen}
                      onChange={handleSelecTipoImagen}
                      label="Vuelo"
                    >
                      <MenuItem value="0" disabled>
                        {"Seleccione una opción"}
                      </MenuItem>
                      {catTipoImagenes.map((item, index) => (
                        <MenuItem
                          key={item.IdTipoImagen}
                          value={item.IdTipoImagen}
                        >
                          {`${item.Descripcion}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {idTipoImagen > 0 && (
                    <UploadInput files={file} setFiles={setFile} />
                  )}
                </Grid>

                <Grid item xs={12} className={classes.modalBotonesCenter} style={{ display: 'flex', flexDirection:"column", alignItems: 'center', justifyContent: 'center' }}>
                  <Typography variant="h6" style={{ marginBottom: '15px' }}>
                    { paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista === 0 && "No hay paquete mayorista configurado" }
                  </Typography>
                  <Button
                    onClick={onGuardar}
                    variant="contained"
                    color="secondary"
                    className={classes.modalBoton}
                    disabled={(file.length > 0 ? false : true) || (paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista === 0)}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotones}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              Aplicar
            </Button>
            <Button
              onClick={onGaleria}
              variant="contained"
              color="primary"
              className={classes.modalBoton}
              disabled={paqueteSelect?.PaqueteMayorista?.IdPaqueteMayorista === 0}
            >
               {isGaleria ? "Subir nuevas imágenes" : "Ver galería"}
            </Button>
          </Grid>
        </Grid>
      </ModalBase>
  )
}
export default FPaquetesGaleria